import 'client-only';

import { atom, useAtom } from 'jotai';

import { type Card } from '@/types/productSelectionAndCheckout/types';

export const modalCardAtom = atom<undefined | Card>(undefined);

export const useProductIngredientsModalState = () => {
  const [modalCard, setModalCard] = useAtom(modalCardAtom);

  return {
    modalCard,
    setModalCard,
    dismissModal: () => setModalCard(undefined),
  };
};
